import BrowserDetector from 'browser-dtector'

export const getBrowser = (): BrowserDetector => {
    return new BrowserDetector(window.navigator.userAgent)
}

export const isIpad = (browser: BrowserDetector) => {
    const ua = browser.userAgent

    if (ua && /iPad/.test(ua)) {
        return true
    }

    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}

// export const isMobileDevice = () => {
//     const { userAgent } = getBrowser()
//     if (!userAgent) {
//         return false
//     }
//     return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent));
// }

export const isWechatBrowserOrMiniProgram = () => {
    const agent = getBrowser().userAgent?.toLocaleLowerCase()
    return !!agent?.includes('miniprogram') || !!agent?.includes('micromessenger')
}

export const isWechatBrowser = () => {
    const agent = getBrowser().userAgent?.toLocaleLowerCase()
    return !!agent?.includes('micromessenger') && !isMiniprogram()
}

export const isMiniprogram = () => {
    const agent = getBrowser().userAgent?.toLocaleLowerCase()
    return !!agent?.includes('miniprogram')
}

export const isIosPlatform = () => {
    const platform = getBrowser().getBrowserInfo().platform?.toString().toLocaleLowerCase()
    return platform === 'ipad' || platform === 'iphone' || platform === 'macintosh'
}

export const isSafaris = () => {
    const userAgent = getBrowser().userAgent?.toLowerCase() ?? ''
    return userAgent.includes('safari') && !userAgent.includes('chrome')
}

export function imageElementToPngFile(imageElement: HTMLImageElement, filename = 'screenshot.png'): Promise<File | null> {
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas')
        canvas.width = imageElement.width
        canvas.height = imageElement.height

        const ctx = canvas.getContext('2d')
        if (!ctx) {
            resolve(null)
            return
        }
        ctx.drawImage(imageElement, 0, 0)

        canvas.toBlob(pngBlob => {
            if (pngBlob) {
                resolve(new File([pngBlob], filename, { type: 'image/png' }))
            } else {
                reject(new Error('Failed to convert image to PNG'))
            }
        }, 'image/png')
    })
}
